<template>
  <div>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  created() {
    this.$store.commit("setSelectedTab", "franchises");
  },
};
</script>